import { Settings, Database, Shield, Bell, Mail, FileText, Info } from 'lucide-react';
import { Card, CardHeader, CardContent } from '../core/Card';
import { Button } from '../core/Button';

export function SystemView() {
  return (
    <div className="bg-[#f5f5f5] min-h-screen p-4 md:p-8">
      <div className="max-w-[1400px] mx-auto">
        {/* System Settings Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {/* General Settings */}
          <Card>
            <CardHeader
              title="Allgemeine Einstellungen"
              subtitle="Systemweite Konfiguration"
              borderBottom
            />
            <CardContent>
              <div className="space-y-4">
                <div className="flex items-start gap-3 p-3 bg-[#f5f5f5] rounded-[8px] cursor-pointer hover:bg-gray-100 transition-colors">
                  <div className="size-10 bg-blue-50 rounded-lg flex items-center justify-center shrink-0">
                    <Settings className="size-5 text-blue-700" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-[#1c1c1c] text-[15px] font-medium mb-1">
                      Systemparameter
                    </h3>
                    <p className="text-[#6b6b6b] text-[13px]">
                      Arbeitszeitmodelle, Sollstunden, Pausenregelungen
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-3 bg-[#f5f5f5] rounded-[8px] cursor-pointer hover:bg-gray-100 transition-colors">
                  <div className="size-10 bg-green-50 rounded-lg flex items-center justify-center shrink-0">
                    <Database className="size-5 text-green-700" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-[#1c1c1c] text-[15px] font-medium mb-1">
                      Datensicherung
                    </h3>
                    <p className="text-[#6b6b6b] text-[13px]">
                      Backup-Einstellungen und Datenexport
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-3 bg-[#f5f5f5] rounded-[8px] cursor-pointer hover:bg-gray-100 transition-colors">
                  <div className="size-10 bg-purple-50 rounded-lg flex items-center justify-center shrink-0">
                    <Shield className="size-5 text-purple-700" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-[#1c1c1c] text-[15px] font-medium mb-1">
                      Sicherheit & Berechtigungen
                    </h3>
                    <p className="text-[#6b6b6b] text-[13px]">
                      Zugriffskontrolle und Rollen verwalten
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Notifications & Communication */}
          <Card>
            <CardHeader
              title="Benachrichtigungen"
              subtitle="E-Mail und System-Benachrichtigungen"
              borderBottom
            />
            <CardContent>
              <div className="space-y-4">
                <div className="flex items-start gap-3 p-3 bg-[#f5f5f5] rounded-[8px] cursor-pointer hover:bg-gray-100 transition-colors">
                  <div className="size-10 bg-orange-50 rounded-lg flex items-center justify-center shrink-0">
                    <Bell className="size-5 text-orange-700" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-[#1c1c1c] text-[15px] font-medium mb-1">
                      Benachrichtigungsregeln
                    </h3>
                    <p className="text-[#6b6b6b] text-[13px]">
                      Wann und wie sollen Benachrichtigungen versendet werden
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-3 bg-[#f5f5f5] rounded-[8px] cursor-pointer hover:bg-gray-100 transition-colors">
                  <div className="size-10 bg-red-50 rounded-lg flex items-center justify-center shrink-0">
                    <Mail className="size-5 text-red-700" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-[#1c1c1c] text-[15px] font-medium mb-1">
                      E-Mail-Einstellungen
                    </h3>
                    <p className="text-[#6b6b6b] text-[13px]">
                      SMTP-Konfiguration und E-Mail-Vorlagen
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 p-3 bg-[#f5f5f5] rounded-[8px] cursor-pointer hover:bg-gray-100 transition-colors">
                  <div className="size-10 bg-teal-50 rounded-lg flex items-center justify-center shrink-0">
                    <FileText className="size-5 text-teal-700" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-[#1c1c1c] text-[15px] font-medium mb-1">
                      Vorlagen & Texte
                    </h3>
                    <p className="text-[#6b6b6b] text-[13px]">
                      Textbausteine und Dokumentenvorlagen anpassen
                    </p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* System Information */}
          <Card className="md:col-span-2">
            <CardHeader
              title="System-Informationen"
              subtitle="Version und Lizenz"
              borderBottom
            />
            <CardContent>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div>
                  <p className="text-[#6b6b6b] text-[13px] mb-1">Version</p>
                  <p className="text-[#1c1c1c] text-[16px] font-medium">
                    ENTRO v2.4.1
                  </p>
                </div>
                <div>
                  <p className="text-[#6b6b6b] text-[13px] mb-1">Lizenz</p>
                  <p className="text-[#1c1c1c] text-[16px] font-medium">
                    Enterprise
                  </p>
                </div>
                <div>
                  <p className="text-[#6b6b6b] text-[13px] mb-1">Letztes Update</p>
                  <p className="text-[#1c1c1c] text-[16px] font-medium">
                    02.01.2026
                  </p>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t border-gray-200">
                <div className="flex items-center gap-3">
                  <Button variant="primary">
                    Update prüfen
                  </Button>
                  <Button variant="outline">
                    Support kontaktieren
                  </Button>
                  <Button variant="outline">
                    Dokumentation
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* Info Box */}
        <div className="mt-6 bg-blue-50 border border-blue-200 rounded-[10px] p-4">
          <div className="flex items-start gap-3">
            <div className="size-10 bg-blue-100 rounded-lg flex items-center justify-center shrink-0">
              <Info className="size-5 text-blue-700" />
            </div>
            <div className="flex-1">
              <h3 className="text-[#1c1c1c] text-[16px] font-medium mb-1">
                System-Einstellungen
              </h3>
              <p className="text-[#6b6b6b] text-[14px]">
                Hier können systemweite Einstellungen vorgenommen werden. Änderungen wirken sich auf alle Benutzer aus. Bitte gehen Sie bei Änderungen sorgfältig vor.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
